














import Vue from 'vue';
import ValidationHelper from '@/helpers/ValidationHelper';

export default Vue.extend({
  name: `ArrowIconNew`,
  props: {
    color: {
      default: `currentColor`,
      type: String,
      validator: prop => ValidationHelper.checkIfStringIsHexColor(prop) || prop === `currentColor`,
    },
    title: {
      default: `Arrow`,
      type: String,
    },
  },
});
